import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import LoginView from "../../login/Login.view";
import MainView from "../../main/Main.view";
import { useAppController } from "../App.controller";
import UserManagementView from "../../user-management/UserManagement.view.tsx";
import ReportingView from "../../reporting/Reporting.view.tsx";
import AdministrationView from "../../administration/Administration.view.tsx";
import ReportView from "../../report/Report.view.tsx";

export default function AppDesktopView() {
  const { token } = useAppController();

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={token ? "/dashboard" : "/login"} replace />}
        />
        <Route
          path="/login"
          element={
            !token ? <LoginView /> : <Navigate to="/dashboard" replace />
          }
        />
        <Route
          path="/dashboard"
          element={token ? <MainView /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/administration"
          element={
            token ? <AdministrationView /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/user-management"
          element={
            token ? <UserManagementView /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/reporting"
          element={token ? <ReportingView /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/report"
          element={token ? <ReportView /> : <Navigate to="/login" replace />}
        />
        <Route
          path="*"
          element={<Navigate to={token ? "/dashboard" : "/login"} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}
